import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Home } from './Home';
import { Head } from './common/Head';
//import CacheStorage from '../services/CacheStorage';
import NetworkStatusObserver from './NetworkStatusObserver';
import ReactNotification from "react-notifications-component";
import Courtesy from './Courtesy';
import { showNotification } from './BaseNotification';

export class Layout extends Component {
  static displayName = Layout.name;

  constructor(props) {
    super(props);

    //this.cacheStorage = new CacheStorage();

    this.state = {
      offlineQueueCount: null,
      synchyng: false
    }
  }

  async componentDidMount() {
    console.log(`Layout.componentDidMount:`);
  }
  /*
  flushQueue = online => {
    console.log(`Layout.flushQueue: online ${online}`);
    if (online) this.cacheStorage.flushQueue();
  };
  */

  setSynchStatus = message => {
    console.log(`Layout.setSynchStatus: message:`, message);
    if (message.infoMsg)
      showNotification.info("Info", message.infoMsg);
    if (message.warnMsg)
      showNotification.warning("Warning", message.warnMsg);
    if (message.errMsg)
      showNotification.error("Error", message.errMsg);
    if (message.sucMsg)
      showNotification.success("Success", message.sucMsg);

    if (message.queueLength != null) {
      this.setState({ offlineQueueCount: message.queueLength });
    }
    if (message.synching != null) {
      this.setState({ synching: message.synching });
      if (message.synching) {
        showNotification.info("Synching", 'Operation started');
        console.log('Layout.setSynchStatus: Synch operation started');
      } else if (!message.error) {
        showNotification.success("Synching", 'Operation ended successfully');
        console.log('Layout.setSynchStatus: Synch operation ended successfully');
      } else {
        showNotification.error("Synching", `Operation ended with ${message.queueLength} errors and ${message.minRetriesLeft} retries left. Queue size: ${message.totalQueueSizeKB} KB`);
        console.error(`Layout.setSynchStatus: Synching operation ended with ${message.queueLength} errors and ${message.minRetriesLeft} retries left. Queue size: ${message.totalQueueSizeKB} KB`);
      }
    }
  };

  render() {
    console.log(`Layout.render: navigator.onLine: ${navigator.onLine}`);
    const synchStatus = {
      synching: this.state.synching,
      pending: this.state.offlineQueueCount
    };

    return (
      <div>
        <ReactNotification />
        <Head synchStatus={synchStatus}/>
        <div className="main-container">
          <Switch>
            <Route exact path='/' component={Courtesy} />
            <Route exact path='/:worksiteId/:projectId' component={Home}/>
            <Redirect from="*" to="/" />
          </Switch>
          {this.props.children}
        </div>
        <NetworkStatusObserver
          onMessageReceived={this.setSynchStatus}
        />
      </div>
    );
  }
}
